import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - questions banner';

export default {
  ...defineTracking({
    toggleQuestion: {
      category,
      action: 'click',
      label: '{id} toggle question',
      description:
        'This event is triggered when a user toggles a question. ' +
        '{id} represents the id of the question the user toggled.',
    },
  }),
};
